
import React from 'react';
import propTypes from 'prop-types';
import {CSSTransitionGroup} from 'react-transition-group';

import './style.css';

Popup.propTypes = {
  visible: propTypes.bool.isRequired,
  duration: propTypes.number.isRequired,
  timingFunction: propTypes.string.isRequired,
  direction: propTypes.oneOf(['left', 'right', 'top', 'bottom']).isRequired,
};

Popup.defaultProps = {
  visible: false,
  duration: 400,
  timingFunction: 'ease',
  direction: 'bottom'
};

export default function Popup(props) {
  let {
    visible,
    duration,
    timingFunction,
    direction,
    style,
    className,
    children,
    ...rest
  } = props;
  className = `${className} popup`;
  style = {
    ...style,
    transitionDuration: (duration + 'ms'),
    transitionTimingFunction: timingFunction
  };

  return (
    <CSSTransitionGroup
      component={Container}
      transitionName='popup'
      transitionEnterTimeout={duration}
      transitionLeaveTimeout={duration}>

      {visible ? (
        <div {...rest} className={className} style={style}>
          <div
            className={`popup-main popup-main-${direction}`}
            style={style}>
            {children}
          </div>
        </div>
      ) : null}
    </CSSTransitionGroup>
  );
}

function Container(props) {
  return props.children.length ? props.children[0] : null;
}



// WEBPACK FOOTER //
// ./src/components/Popup/index.js